// Croqui: `components/Card.tsx`.
//
// O croqui usa gradiente + sombra; aqui a profundidade é borda baixa e nada de sombra
// (`spec/17` §7 item 4). Registrado em "Questões abertas" da WEB-50.

import type { ReactNode } from 'react';
import { cn } from '../../lib/cn.ts';

/** Cartão: borda de cartão, raio 14. `active` troca a borda pelo dourado. */
export function Card({
  children,
  active = false,
  className,
}: {
  children: ReactNode;
  active?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'min-w-0 rounded-card border bg-card p-3.5',
        active ? 'border-gold' : 'border-card-border',
        className,
      )}
    >
      {children}
    </div>
  );
}
